<template>
	<div id="customize">
		<div class="title">
			自定义年龄区间
		</div>
		<div class="content">
			<div class="item">
				<div class="item-title" @click="back()">
					恢复默认设置
				</div>
				<div class="item-container">
					<div class="panel-title">
						<a-row>
							<a-col :span="8" class="item-age">年龄区间</a-col>
							<a-col :span="16" class="item-reason">区间条件描述</a-col>
						</a-row>
					</div>
					<div class="panel-item">
						<a-form
							:form="form"
							@submit="handleSubmit"
						>
							<a-row>
								<a-col :span="8">
									<a-form-item
										v-for="(k, index) in form.getFieldValue('keys')"
										:key="index"
										:required="false"
									>
										<a-input
											v-decorator="[
											`names[${k}]`,
											{
												initialValue: names[k],
												validateTrigger: ['change', 'blur'],
												rules: [{
												required: true,
												whitespace: true,
												message: '请输入年龄区间或删除整行',
												},{validator: handleAge}],
											}
											]"
											placeholder="年龄区间"
											style="width: 60%; margin-left: 8px"
										/>
									</a-form-item>
								</a-col>
								<a-col :span="16" class="item-reason">
									<a-form-item
										v-for="(k, index) in form.getFieldValue('keys')"
										:key="index"
										:required="false"
									>
										<span style="width: 60%; display: inline-block;">患者年龄{{names[k]}}</span>
										<a-icon
											v-if="form.getFieldValue('keys').length > 1"
											class="dynamic-delete-button"
											type="minus-circle-o"
											:disabled="form.getFieldValue('keys').length === 1"
											@click="() => remove(k)"
										/>
									</a-form-item>
								</a-col>
							</a-row>
							<a-form-item v-if="isVisibleAddBtn" v-bind="formItemLayoutWithOutLabel">
								<a-button
									type="dashed"
									style="width: 60%"
									@click="add"
								>
									<a-icon type="plus"/>
									添加区间
								</a-button>
							</a-form-item>
							<a-form-item v-bind="formItemLayoutWithOutLabel">
								<a-button
									type="primary"
									html-type="submit"
								>
									确定
								</a-button>
							</a-form-item>
						</a-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	let id = 5
	export default {
		data() {
			return {
				isDefault: 1,
				firstAgeList: [],
				names: [],
				names1: ['患者年龄<1', '患者年龄>=1 and 患者年龄<=3', '患者年龄>=4 and 患者年龄<=6', '患者年龄>=7 and 患者年龄<=10', '患者年龄>10'],
				formItemLayout: {
					labelCol: {
						xs: {span: 12},
						sm: {span: 4},
					},
					wrapperCol: {
						xs: {span: 12},
						sm: {span: 20},
					},
				},
				formItemLayoutWithOutLabel: {
					wrapperCol: {
						xs: {span: 12, offset: 0},
						sm: {span: 20, offset: 4},
					},
				},
				isVisibleAddBtn: true,
			};
		},
		props: ['firstAgeData'],
		beforeCreate() {
			let _this = this
			_this.form = _this.$form.createForm(this);
			_this.form.getFieldDecorator('keys', {initialValue: ['0']});
			this.$get('stat/getLastFirstAge', {isDefault: 0}).then(
				res => {
					if (res.data.code == 1) {
						let resData = res.data.data;
						this.firstAgeList = JSON.parse(resData);
						this.firstAgeList.isDefault = 0;
						this.names = this.firstAgeList.paramList;
						if (this.names.length > 5) {
							this.isVisibleAddBtn = false;
						}
						let initialValue = [];
						this.names.forEach((item, i) => {
							initialValue.push(i.toString());
						})
						_this.form.getFieldDecorator('keys', {initialValue: initialValue, preserve: true});
					}
				},
				err => {
					console.log('getLastFirstAge err', err);
				}
			);

		},
		mounted() {
			//this.getLastFirstAge(0);
		},
		methods: {
			handleAge(rule, value, callback) {
				if (value.indexOf('~') > 0 || value.indexOf('+') > 0) {
					callback();
				}else{
					callback('请输入年龄区间为[1~2或10+]');
				}
			},
			getLastFirstAge(isDefault) {
				this.$get('stat/getLastFirstAge', {isDefault: isDefault}).then(
					res => {
						if (res.data.code == 1) {
							let resData = res.data.data;
							this.firstAgeList = JSON.parse(resData);
							this.firstAgeList.isDefault = this.isDefault;
							this.names = this.firstAgeList.paramList;
						}
					},
					err => {
						console.log('getLastFirstAge err', err);
					}
				);
			},
			remove(k) {
				const {form} = this;
				// can use data-binding to get
				const keys = form.getFieldValue('keys');
				// We need at least one passenger
				if (keys.length === 1) {
					return;
				}

				// can use data-binding to set
				form.setFieldsValue({
					keys: keys.filter(key => key !== k),
				});
				if (keys.length < 7) {
					this.isVisibleAddBtn = true;
				}
			},

			add() {
				const {form} = this;
				// can use data-binding to get
				const keys = form.getFieldValue('keys');
				const nextKeys = keys.concat(++id);
				// can use data-binding to set
				// important! notify form to detect changes
				form.setFieldsValue({
					keys: nextKeys,
				});
				if (keys.length == 5) {
					this.isVisibleAddBtn = false;
				}
			},
			back() {
				this.form = this.$form.createForm(this);
				this.form.getFieldDecorator('keys', {initialValue: ['0', '1', '2', '3', '4'], preserve: true});
				this.getLastFirstAge(1);
				this.names1 = ['患者年龄<1', '患者年龄>=1 and 患者年龄<=3', '患者年龄>=4 and 患者年龄<=6', '患者年龄>=7 and 患者年龄<=10', '患者年龄>10']

			},
			handleSubmit(e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if (!err) {
						let paramList = [];
						if (values.names.length > 0) {
							values.names.forEach((item, i) => {
								if (item) {
									paramList.push(item);
								}
							});
						}
						let firstAgeList = {
							isDefault: 0,
							paramList: paramList
						};
						this.$emit('getNumByFirstAge', JSON.stringify(firstAgeList));
						this.$emit('close');
					}
				});
			},
		},
	}
</script>
<style lang="scss" scoped>
	#customize {
		width: 682px;
		padding-top: 106px;
		margin: 0 auto;
	}

	.content {
		width: 682px;
		height: 402px;
		margin-top: 55px;
		background: rgba(255, 255, 255, 1);
		// border:1px solid rgba(243,245,247,1);
		.item {
			width: 587px;
			margin: 0 auto
		}
		.item-title {
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(66, 142, 247, 1);
			text-align: right;
			cursor: pointer;
			.title {
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);

			}
			.item-container {
				width: 587px;
				height: 338px;
				// border:1px solid rgba(240,242,245,1);
			}
			.panel-title {
				height: 32px;
				background: rgba(249, 251, 251, 1);
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(164, 164, 164, 1);
			}
			.item-age {
				padding-left: 30px;
				line-height: 32px;
			}
			.item-reason {
				line-height: 32px;
			}
			.dynamic-delete-button {
				cursor: pointer;
				position: relative;
				top: 4px;
				font-size: 24px;
				color: #999;
				transition: all .3s;
			}
			.dynamic-delete-button:hover {
				color: #777;
			}
			.dynamic-delete-button[disabled] {
				cursor: not-allowed;
				opacity: 0.5;
			}
		}
	}

	.content {
		width: 682px;
		min-height: 432px;
		margin-top: 55px;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(243, 245, 247, 1);
		.item {
			width: 587px;
			margin: 0 auto
		}
		.item-title {
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(66, 142, 247, 1);
			text-align: right;
			cursor: pointer;

		}
		.item-container {
			width: 587px;
			height: 338px;
			border: 1px solid rgba(240, 242, 245, 1);
		}
		.panel-title {
			height: 32px;
			background: rgba(249, 251, 251, 1);
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(164, 164, 164, 1);
		}
		.item-age {
			padding-left: 30px;
			line-height: 32px;
		}
		.item-reason {
			line-height: 32px;
		}
		.dynamic-delete-button {
			cursor: pointer;
			position: relative;
			top: 4px;
			font-size: 24px;
			color: #999;
			transition: all .3s;
		}
		.dynamic-delete-button:hover {
			color: #777;
		}
		.dynamic-delete-button[disabled] {
			cursor: not-allowed;
			opacity: 0.5;
		}
	}
</style>
